module.exports = __webpack_public_path__ + "img/3.438e3b5c.png";